import { render } from "./2.Discover.vue?vue&type=template&id=666dfbaf&scoped=true"
import script from "./2.Discover.vue?vue&type=script&lang=js"
export * from "./2.Discover.vue?vue&type=script&lang=js"

import "./2.Discover.vue?vue&type=style&index=0&id=666dfbaf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666dfbaf"]])

export default __exports__